var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('a',{on:{"click":_vm.download}},[_c('img',{attrs:{"src":require("../../assets/icon/下载icon.png")}})])]),_c('iframe',{attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }